import ResourceAudioPage from "@/components/ResourceAudioPage";
import { SLEEP_AUDIO_URL } from "@/content";

export default function SleepPage() {
  return (
    <ResourceAudioPage
      title="Sleep"
      subtitle="A slow audio companion to help your system soften its guard, quiet the day, and settle toward rest."
      label="Sleep · Guided Audio"
      src={SLEEP_AUDIO_URL}
      testId="sleep-page"
    />
  );
}
